import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiGetAllTeacherDailyLessons, apiGetAllTeacherHours } from '../api/apiCommands'

export const getTeacherDailyLessonsState = createAsyncThunk(
  'teacherSalary/getTeacherDailyLessonsState',
  async (token) => {
    return apiGetAllTeacherDailyLessons(token)
  }
)

export const getTeacherHoursState = createAsyncThunk(
  'teacherSalary/getTeacherHoursState',
  async (token) => {
    return apiGetAllTeacherHours(token)
  }
)

const initialState = {
  totalDailylessons: 0,
  items: [],
  details: null,
  status: null,
  error: null
}

const teacherSalarySlice = createSlice({
  name: 'teacherSalary',

  initialState,
  
  reducers: {
    setNewStatus(state, action) {
      state.status = action.payload
    },

    nullifyState(state) {
      state.totalDailylessons = initialState.totalDailylessons
      state.items = initialState.items
      state.details = initialState.details
      state.status = initialState.status
      state.error = initialState.error
    }
  },

  extraReducers: {
    [getTeacherDailyLessonsState.pending]: (state, action) => {
      state.status = 'loading'
    }, 
    
    [getTeacherHoursState.pending]: (state, action) => {
      state.status = 'loading'
    },

    [getTeacherDailyLessonsState.fulfilled]: (state, action) => {
      const response = action.payload

      if (response.fetchStatus) {
        state.error = 401
      } else {
        state.totalSubjects = response.totalItems
        state.items = response.items
        state.status = 'success'
        state.error = null
      }
    },

    [getTeacherHoursState.fulfilled]: (state, action) => {
      const response = action.payload

      if (response.fetchStatus) {
        state.error = 401
      } else {
        state.details = response
        state.status = 'success'
        state.error = null
      }
    },

    [getTeacherDailyLessonsState.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    },

    [getTeacherHoursState.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    },
  }
})

export default teacherSalarySlice.reducer
export const { setNewStatus, nullifyState } = teacherSalarySlice.actions